import { makeObservable } from "@faire/web/common/makeObservable";
import { getCurrentPath } from "@faire/web/common/Path";
import { singletonGetter } from "@faire/web/common/singletons/getter";
import { createStoreHook } from "@faire/web/ui/hooks/useStore";
import { action, computed, observable } from "mobx";
import { matchPath } from "react-router-dom";

import { FirstOrderIncentiveStore } from "@faire/retailer/stores/domain/FirstOrderIncentiveStore";
import { AppModalStore } from "@faire/retailer/stores/ui/AppModalStore";

const WHITELIST_PAGES = ["/"];

/**
 * @deprecated prefer to use `useCheckoutNudgeStore` or `withStores` instead
 */
class CheckoutNudgeStore {
  constructor() {
    makeObservable(this);
  }

  /**
   * @trackfunction
   */
  static get = singletonGetter(CheckoutNudgeStore);

  @observable
  // track whether we have nudged retailer on the page,
  // if true, we shouldn't show other modal to interrupt
  // (e.g. if we nudge retailer, we shouldn't show style quiz modal in the same page)
  checkoutNudgedInCurrentPage: boolean = false;

  @observable
  /**
   *  Controls whether we should nudge retailer in current user session.
   *  We shouldn't nudge retailer if
   *  1. some modal is showing on the first page of user session
   *  2. already nudged retailer in the current user session
   */
  private shouldConsiderNudgeInTheSession: boolean =
    !AppModalStore.get().isModalShowing;

  @observable
  isOpen = false;

  @action
  updateHasNudgedInCurrentPage = (hasNudgedInCurrentPage: boolean) => {
    this.checkoutNudgedInCurrentPage = hasNudgedInCurrentPage;
  };

  @action
  updateWhenVisible = () => {
    this.shouldConsiderNudgeInTheSession = false;
    CheckoutNudgeStore.get().updateHasNudgedInCurrentPage(true);
    this.isOpen = true;
  };

  @action
  onCloseClick = () => {
    this.isOpen = false;
  };

  @computed
  get hasNudgeToFirstOrderIncentive(): boolean {
    return FirstOrderIncentiveStore.get().shouldShowDeadlineNudge;
  }

  // we should hide the pop up if requirement is not met or
  // user has already been nudged and close the nudge
  shouldShowNudge = (pathName?: string) => {
    const currentPathName = pathName ?? getCurrentPath().pathname;

    const isWhitelistPage = !!WHITELIST_PAGES.find((whitelistPage) =>
      matchPath(currentPathName, {
        path: whitelistPage,
        exact: true,
      })
    );

    return (
      (this.shouldConsiderNudgeInTheSession || this.isOpen) && isWhitelistPage
    );
  };
}

export const useCheckoutNudgeStore = createStoreHook(CheckoutNudgeStore);
